const Logo = {
  props: [
    {
      name: 'title',
      default: '',
      type: 'string',
      desc: '标题'
    },
    {
      name: 'expand',
      default: '',
      type: 'boolean',
      desc: '展开模式'
    }
  ]
}

export default [
  {
    name: 'Logo API',
    content: Logo
  }
]
